import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { IContratistaModel } from 'src/app/models/interfaces/contratista/IContratistaModel';
import { IFilterContratistaModel } from 'src/app/models/interfaces/contratista/IFilterContratistaModel';
import { IFilterSolicitudModel } from 'src/app/models/interfaces/solicitud/IFilterSolicitudModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContratistaService {
  private configUrl = [environment.apiGatewayUrl, 'contratistas'].join('/');

  constructor(private http: HttpClient) {}

  getListPaged(
    model: IFilterContratistaModel
  ): Observable<SearchResultModel<IContratistaModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if (model.ruc !== '') {
      queryParams.push(`ruc=${model.ruc}`);
    }
    queryParams.push(`idEstado=${model.idEstado}`);

    if(model.idSede > 0){
      queryParams.push(`sedes=${model.idSede}`);
    }

    if(model.companias.length > 0){
      queryParams.push(`companias=${model.companias.join(',')}`); 
    }

    return this.http.get<SearchResultModel<ContratistaModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
      );
  }

  getList(
    model: IFilterContratistaModel
  ): Observable<IContratistaModel[]> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`idEstado=${model.idEstado}`);

    if(model.idContratistas.length > 0){
      queryParams.push(`ids=${model.idContratistas.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if (model.ruc !== '') {
      queryParams.push(`ruc=${model.ruc}`);
    }
    if(model.idSede > 0){
      queryParams.push(`sedes=${model.idSede}`);
    }

    if(model.companias.length > 0){
      queryParams.push(`companias=${model.companias.join(',')}`); 
    }

    return this.http.get<ContratistaModel[]>(
      this.configUrl + '/all?'+ queryParams.join('&')
      );
  }

  getListWithEngie(
    model: IFilterContratistaModel
  ): Observable<IContratistaModel[]> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`idEstado=${model.idEstado}`);

    if(model.idContratistas.length > 0){
      queryParams.push(`ids=${model.idContratistas.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if (model.ruc !== '') {
      queryParams.push(`ruc=${model.ruc}`);
    }

    return this.http.get<ContratistaModel[]>(
      this.configUrl + '/all-engie?'+ queryParams.join('&')
      );
  }

  getById(id: number): Observable<IContratistaModel> {
    return this.http.get<IContratistaModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IContratistaModel) {
    return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
  }

  update(model: IContratistaModel) {
    return this.http.put<IContratistaModel>(
      `${this.configUrl}/${model.idContratista}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<IContratistaModel>(`${this.configUrl}/${id}`);
  }
}
